import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useI18n } from "../../i18n";
import IntroComponent from "../general/IntroComponent";
import CommonForm from "../general/CommonForm";

const Login = () => {
  const auth = useAuth(); // tək instansiya — form da bunu istifadə edir
  const { t } = useI18n();

  return (
    <div className="w-full max-w-5xl bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col md:flex-row">
      {/* Sol tərəf */}
      <IntroComponent
        title={t("auth.welcome_title")}
        description={t("auth.welcome_desc")}
      />

      {/* Sağ tərəf (Login formu) */}
      <div className="md:w-1/2 p-8 sm:p-10">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-left">
          {t("auth.login_title")}
        </h2>

        {auth.errors.general && (
          <div className="mb-4 text-red-600 text-sm bg-red-50 border border-red-200 rounded-lg px-3 py-2">
            {auth.errors.general}
          </div>
        )}

        <CommonForm isLogin={true} auth={auth} />

        <p className="text-center text-gray-600 text-sm mt-4">
          {t("auth.no_account")}{" "}
          <Link
            to="/register"
            className="text-indigo-500 font-semibold hover:underline"
          >
            {t("auth.register_link")}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
